// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/purecss/build/pure.css
// module id = 907
// module chunks = 1